// extracted by mini-css-extract-plugin
module.exports = {"container":"forgotPassword_container__1GyzO","logo":"forgotPassword_logo__15qtf"};